/// <reference types="@angular/localize" />

import {enableProdMode, importProvidersFrom} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {mergeConfig} from '@sbb-esta/lyne-elements/core/config.js';
import {AppComponent} from './app/app.component';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {CdDateAdapter} from '~/app/services/adapter/CdDateAdapter';

if (environment.production) {
  enableProdMode();
  if (['prod', 'int'].includes(environment.stage)) {
    console.log('disabling logging...');
    console.log = () => {};
  }
} else {
  // some errors are not caught/handled by Angular:
  window.addEventListener('error', e => console.error('Error occurred: ', e));
}

mergeConfig({
  icon: {namespaces: new Map<string, string>().set('cd', document.baseURI + 'assets/icons/')},
  tooltip: {openDelay: 500},
  popover: {openDelay: 500},
  // document.documentElement.lang is a workaround, as LOCALE_ID is not accessible outside angular DI:
  datetime: {dateAdapter: new CdDateAdapter(document.documentElement.lang || 'de-CH')},
  language: document.documentElement.lang || 'de-CH'
});

bootstrapApplication(AppComponent, {providers: [importProvidersFrom(AppModule)]}).catch(err => console.error(err));
